"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = DatePickerModal;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _RenderIf = _interopRequireDefault(require("../RenderIf"));

var _styled = require("./styled");

function DatePickerModal(props) {
  var id = props.id,
      className = props.className,
      style = props.style,
      locale = props.locale,
      minDate = props.minDate,
      maxDate = props.maxDate,
      selectionType = props.selectionType,
      variant = props.variant,
      value = props.value,
      onChange = props.onChange,
      onRequestClose = props.onRequestClose,
      isOpen = props.isOpen,
      title = props.title;
  var calendarId = id && "".concat(id, "_calendar");
  return /*#__PURE__*/_react["default"].createElement(_styled.StyledModal, {
    id: id,
    className: className,
    style: style,
    isOpen: isOpen,
    onRequestClose: onRequestClose
  }, /*#__PURE__*/_react["default"].createElement(_RenderIf["default"], {
    isTrue: title
  }, /*#__PURE__*/_react["default"].createElement(_styled.Header, {
    variant: variant
  }, /*#__PURE__*/_react["default"].createElement(_styled.HeaderTitle, null, title))), /*#__PURE__*/_react["default"].createElement(_styled.StyledCalendar, {
    id: calendarId,
    locale: locale,
    minDate: minDate,
    maxDate: maxDate,
    selectionType: selectionType,
    variant: variant,
    value: value,
    onChange: onChange
  }));
}

DatePickerModal.propTypes = {
  /** The id of the outer element. */
  id: _propTypes["default"].string,

  /** A CSS class for the outer element, in addition to the component's base classes. */
  className: _propTypes["default"].string,

  /** An object with custom style applied to the outer element. */
  style: _propTypes["default"].object,

  /**
   * The DatePickerModal locale. Defaults to browser's language.
   */
  locale: _propTypes["default"].string,

  /** The ending of a range of valid dates. The range includes the endDate.
   * The default value is current date + 100 years. */
  maxDate: _propTypes["default"].instanceOf(Date),

  /** The beginning of a range of valid dates. The range includes the startDate.
   * The default value is current date - 100 years. */
  minDate: _propTypes["default"].instanceOf(Date),

  /** The type of the selection. It can be a single date or a range. The default value is 'single'. */
  selectionType: _propTypes["default"].oneOf(['single', 'range']),

  /** The calendar type. Defaults to 'single' */
  variant: _propTypes["default"].oneOf(['single', 'double']),

  /** The action triggered when a value attribute changes. */
  onChange: _propTypes["default"].func,

  /** Sets the date for the DatePickerModal programmatically. */
  value: _propTypes["default"].oneOfType([_propTypes["default"].instanceOf(Date), _propTypes["default"].string, _propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].instanceOf(Date), _propTypes["default"].string]))]),

  /** Controls whether the DatePickerModal is opened or not. */
  isOpen: _propTypes["default"].bool,

  /** The action triggered when the component request to close
   *  (e.g click close button, press esc key or click outside). */
  onRequestClose: _propTypes["default"].func,

  /** The title can include text or another component,
   * and is displayed in the header of the component. */
  title: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node])
};
DatePickerModal.defaultProps = {
  id: undefined,
  className: undefined,
  style: undefined,
  locale: undefined,
  maxDate: undefined,
  minDate: undefined,
  selectionType: 'single',
  variant: 'single',
  value: undefined,
  isOpen: false,
  onChange: function onChange() {},
  onRequestClose: function onRequestClose() {},
  title: undefined
};